import { render, staticRenderFns } from "./AddNuveiCardComponent.vue?vue&type=template&id=705ac555&"
import script from "./AddNuveiCardComponent.vue?vue&type=script&lang=js&"
export * from "./AddNuveiCardComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports